// import React, { useState, useEffect } from "react";
// import Sidebar from "../../Components/Sidebar";
// import TopNav from "../../Components/TopNav";
// import {
//   getSubscriptionChitUsersListServ,
//   approveSubscriptionChitUserServ,
//   cancelSubscriptionChitUserServ,
//   closeSubscriptionChitUserServ,
//   exportSubscriptionChitUserServ,
// } from "../../services/subscriptionChit.services";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import NoRecordFound from "../../Components/NoRecordFound";
// import { useNavigate } from "react-router-dom";
// import { triggerFileDownload } from "../../utils/fileDownload";

// function SubscriptionChitUsersList() {
//   const [list, setList] = useState([]);
//   const [showSkelton, setShowSkelton] = useState(false);
//   const [payload, setPayload] = useState({
//     searchKey: "",
//     status: "",
//     pageNo: 1,
//     pageCount: 10,
//   });
//   const [totalPages, setTotalPages] = useState(1);
//     const [statics, setStatics] = useState(null);

//   const navigate = useNavigate();
//   const handleGetUsers = async () => {
//     if (list.length === 0) setShowSkelton(true);
//     try {
//       const response = await getSubscriptionChitUsersListServ(payload);
//       setList(response?.data?.data);
//       setStatics(response?.data?.documentCount);
//       const totalCount = response?.data?.documentCount?.totalCount || 0;
//       setTotalPages(Math.ceil(totalCount / payload.pageCount));
//     } catch (error) {
//       toast.error("Failed to fetch users.");
//     }
//     setShowSkelton(false);
//   };

//   useEffect(() => {
//     handleGetUsers();
//   }, [payload]);

//   const staticsArr = [
//     {
//       title: "Total Chit User",
//       count: statics?.totalCount,
//       bgColor: "#6777EF",
//     },
//     {
//       title: "Pending User",
//       count: statics?.pendingCount,
//       bgColor: "#FF4500",
//     },
//     {
//       title: "Approved User",
//       count: statics?.approvedCount,
//       bgColor: "#00B8D9",
//     },
//     // {
//     //   title: "Reject User",
//     //   count: statics?.rejectCount,
//     //   bgColor: "#007BFF",
//     // },
//     {
//       title: "Completed User",
//       count: statics?.completedCount,
//       bgColor: "#63ED7A",
//     },
//     {
//       title: "Cancelled User",
//       count: statics?.cancelledCount,
//       bgColor: "#FFA426",
//     },
//   ];

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       setPayload({ ...payload, pageNo: newPage });
//     }
//   };

//   const handleApproveUser = async (id) => {
//     try {
//       const response = await approveSubscriptionChitUserServ(id);
//       if (response?.data?.statusCode === 200) {
//         toast.success("User approved successfully.");
//         handleGetUsers();
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Approval failed.");
//     }
//   };

//   const handleCancelUser = async (id) => {
//     try {
//       const response = await cancelSubscriptionChitUserServ(id);
//       if (response?.data?.statusCode === 200) {
//         toast.success("Subscription cancelled successfully.");
//         handleGetUsers();
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Cancellation failed.");
//     }
//   };

//   const handleCloseUser = async (id) => {
//     try {
//       const response = await closeSubscriptionChitUserServ(id);
//       if (response?.data?.statusCode === 200) {
//         toast.success("Subscription closed successfully.");
//         handleGetUsers();
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Closing failed.");
//     }
//   };

//   const handleDownload = async (format) => {
//         try {
//           const response = await exportSubscriptionChitUserServ(payload, format);
//           const ext = format === "excel" ? "xlsx" : format;
//           triggerFileDownload(response.data, `chitUserList.${ext}`);
//         } catch (err) {
//           toast.error("Download failed");
//         }
//       };
  
//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="Subscription" selectedItem="Chit User" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//         <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           >
//             {staticsArr?.map((v, i) => {
//               return (
//                 <div className="col-md-4 col-12 ">
//                   <div className="topCard shadow-sm py-4 px-3 rounded mb-3">
//                     <div className="d-flex align-items-center ">
//                       <div
//                         className="p-2 shadow rounded"
//                         style={{ background: v?.bgColor }}
//                       >
//                         <img src="https://cdn-icons-png.flaticon.com/128/666/666120.png" />
//                       </div>
//                       <div className="ms-3">
//                         <h6>{v?.title}</h6>
//                         <h2 className="text-secondary">{v?.count}</h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           <div className="row m-0 p-0 d-flex align-items-center my-4 topActionForm">
//             <div className="col-lg-2 mb-2 col-md-12 col-12">
//               <h3 className="mb-0 text-bold text-secondary">
//                 Subscription Users
//               </h3>
//             </div>
//             <div className="col-lg-4 mb-2 col-md-12 col-12">
//               <input
//                 className="form-control borderRadius24"
//                 placeholder="Search"
//                 onChange={(e) =>
//                   setPayload({ ...payload, searchKey: e.target.value })
//                 }
//               />
//             </div>
//             <div className="col-lg-3 mb-2 col-md-6 col-12">
//               <select
//                 className="form-control borderRadius24"
//                 onChange={(e) =>
//                   setPayload({ ...payload, status: e.target.value })
//                 }
//               >
//                 <option value="">All Chit User</option>
//                 <option value="pending">Pending</option>
//                 <option value="approved">Approved</option>
//                 <option value="completed">Completed</option>
//                 <option value="cancelled">Cancelled</option>
//               </select>
//             </div>
//             <div className="col-lg-3 mb-2 col-md-6 col-12 dropdown">
//               <button
//                 className="btn w-100 borderRadius24 text-light p-2 dropdown-toggle"
//                 style={{ background: "#227C9D" }}
//                 type="button"
//                 data-bs-toggle="dropdown"
//                 aria-expanded="false"
//               >
//                 Download
//               </button>
//               <ul className="dropdown-menu w-100">
//                 <li>
//                   <button
//                     className="dropdown-item"
//                     onClick={() => handleDownload("txt")}
//                   >
//                     Download as TXT
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     className="dropdown-item"
//                     onClick={() => handleDownload("excel")}
//                   >
//                     Download as Excel
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     className="dropdown-item"
//                     onClick={() => handleDownload("csv")}
//                   >
//                     Download as CSV
//                   </button>
//                 </li>
//               </ul>
//             </div>
//           </div>

//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <table className="table">
//                   <thead>
//                     <tr style={{ background: "#F3F3F3", color: "#000" }}>
//                       <th className="text-center py-3">Sr. No</th>
//                       <th className="text-center py-3">Name</th>
//                       <th className="text-center py-3">Phone</th>
//                       <th className="text-center py-3">Email</th>
//                       <th className="text-center py-3">Location</th>
//                       <th className="text-center py-3">Status</th>
//                       <th className="text-center py-3">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {showSkelton
//                       ? [...Array(10)].map((_, i) => (
//                           <tr key={i}>
//                             {[...Array(7)].map((_, j) => (
//                               <td className="text-center" key={j}>
//                                 <Skeleton />
//                               </td>
//                             ))}
//                           </tr>
//                         ))
//                       : list?.map((v, i) => (
//                           <tr key={v?._id}>
//                             <td className="text-center">
//                               {(payload.pageNo - 1) * payload.pageCount + i + 1}
//                             </td>
//                             <td className="text-center">{v?.name}</td>
//                             <td className="text-center">{v?.phone}</td>
//                             <td className="text-center">{v?.email}</td>
//                             <td className="text-center">{v?.location}</td>
//                             <td className="text-center text-capitalize">
//                               {v?.status}
//                             </td>
//                             <td className="text-center">
//                               {/* Pending */}
//                               {v?.status === "pending" && (
//                                 <div className="d-flex justify-content-center gap-2 flex-wrap">
//                                   <span
//                                     className="badge bg-info p-2"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() =>
//                                       navigate(
//                                         `/subscription-details/${v?._id}`
//                                       )
//                                     }
//                                   >
//                                     View Details
//                                   </span>
//                                   <span
//                                     className="badge bg-success p-2"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() => handleApproveUser(v?._id)}
//                                   >
//                                     Approve
//                                   </span>
//                                   <span
//                                     className="badge bg-danger p-2"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() => handleCancelUser(v?._id)}
//                                   >
//                                     Cancel
//                                   </span>
//                                 </div>
//                               )}

//                               {/* Approved */}
//                               {v?.status === "approved" && (
//                                 <div className="d-flex justify-content-center gap-2 flex-wrap">
//                                   <span
//                                     className="badge bg-info p-2"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() =>
//                                       navigate(
//                                         `/subscription-details/${v?._id}`
//                                       )
//                                     }
//                                   >
//                                     View Details
//                                   </span>
//                                   <span
//                                     className="badge bg-warning text-dark p-2"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() => handleCloseUser(v?._id)}
//                                   >
//                                     Close
//                                   </span>
//                                   <span
//                                     className="badge bg-danger p-2"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() => handleCancelUser(v?._id)}
//                                   >
//                                     Cancel
//                                   </span>
//                                 </div>
//                               )}

//                               {/* Cancelled */}
//                               {v?.status === "cancelled" && (
//                                 <div className="d-flex justify-content-center gap-2 flex-wrap">
//                                   <span
//                                     className="badge bg-info p-2"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() =>
//                                       navigate(
//                                         `/subscription-details/${v?._id}`
//                                       )
//                                     }
//                                   >
//                                     View Details
//                                   </span>
//                                   <span className="badge bg-danger p-2">
//                                     Cancelled
//                                   </span>
//                                 </div>
//                               )}

//                               {/* Completed */}
//                               {v?.status === "completed" && (
//                                 <div className="d-flex justify-content-center gap-2 flex-wrap">
//                                   <span
//                                     className="badge bg-info p-2"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() =>
//                                       navigate(
//                                         `/subscription-details/${v?._id}`
//                                       )
//                                     }
//                                   >
//                                     View Details
//                                   </span>
//                                   <span className="badge bg-success p-2">
//                                     Completed
//                                   </span>
//                                 </div>
//                               )}
//                             </td>
//                           </tr>
//                         ))}
//                   </tbody>
//                 </table>

//                 {list.length === 0 && !showSkelton && <NoRecordFound />}
//               </div>

//               {/* Pagination */}
//               <div className="d-flex justify-content-center mt-3">
//                 <nav>
//                   <ul className="pagination pagination-sm">
//                     <li
//                       className={`page-item ${
//                         payload.pageNo === 1 && "disabled"
//                       }`}
//                     >
//                       <button
//                         className="page-link"
//                         onClick={() => handlePageChange(payload.pageNo - 1)}
//                       >
//                         &lt;
//                       </button>
//                     </li>
//                     {[...Array(totalPages)].map((_, i) => (
//                       <li
//                         key={i}
//                         className={`page-item ${
//                           payload.pageNo === i + 1 && "active"
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(i + 1)}
//                         >
//                           {i + 1}
//                         </button>
//                       </li>
//                     ))}
//                     <li
//                       className={`page-item ${
//                         payload.pageNo === totalPages && "disabled"
//                       }`}
//                     >
//                       <button
//                         className="page-link"
//                         onClick={() => handlePageChange(payload.pageNo + 1)}
//                       >
//                         &gt;
//                       </button>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default SubscriptionChitUsersList;


import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  getSubscriptionChitUsersListServ,
  approveSubscriptionChitUserServ,
  cancelSubscriptionChitUserServ,
  closeSubscriptionChitUserServ,
  exportSubscriptionChitUserServ,
} from "../../services/subscriptionChit.services";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NoRecordFound from "../../Components/NoRecordFound";
import { useNavigate } from "react-router-dom";
import { triggerFileDownload } from "../../utils/fileDownload";

/* ─── Scoped styles ─────────────────────────────────── */
const styles = `
  .sc-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'Segoe UI', sans-serif;
  }

  /* stat grid */
  .sc-stat-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 14px;
    margin-bottom: 20px;
  }
  @media (max-width: 1200px) { .sc-stat-grid { grid-template-columns: repeat(3, 1fr); } }
  @media (max-width: 760px)  { .sc-stat-grid { grid-template-columns: repeat(2, 1fr); } }
  @media (max-width: 480px)  { .sc-stat-grid { grid-template-columns: 1fr; } }

  .sc-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 16px 18px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    gap: 13px;
  }
  .sc-stat-icon {
    width: 44px; height: 44px;
    border-radius: 11px;
    display: flex; align-items: center; justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
  }
  .sc-stat-val {
    font-size: 26px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
  }
  .sc-stat-lbl {
    font-size: 13px;
    color: #aaa;
    margin-top: 4px;
  }

  /* toolbar */
  .sc-toolbar {
    background: #fff;
    border-radius: 14px;
    padding: 16px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }
  .sc-toolbar-title {
    font-size: 19px;
    font-weight: 700;
    color: #1c0a0a;
  }
  .sc-toolbar-right {
    display: flex; align-items: center; gap: 10px; flex-wrap: wrap;
  }
  .sc-input {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 14px;
    color: #555;
    background: #f9f9f9;
    outline: none;
    width: 220px;
  }
  .sc-input:focus { border-color: #f0c0b8; }

  .sc-select {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 12px;
    font-size: 14px;
    color: #555;
    background: #f9f9f9;
    outline: none;
    cursor: pointer;
  }
  .sc-select:focus { border-color: #f0c0b8; }

  /* download dropdown */
  .sc-download-wrap { position: relative; }
  .sc-btn-red {
    height: 40px;
    padding: 0 20px;
    border-radius: 10px;
    background: #a60808;
    color: #fff;
    border: none;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex; align-items: center; gap: 7px;
    white-space: nowrap;
  }
  .sc-btn-red:hover { background: #a93226; }
  .sc-btn-red i { font-size: 16px; }
  .sc-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    background: #fff;
    border: 1px solid #f0eded;
    border-radius: 10px;
    padding: 6px;
    z-index: 100;
    min-width: 180px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  }
  .sc-dropdown-item {
    display: block; width: 100%;
    padding: 9px 14px;
    font-size: 14px; color: #444;
    background: none; border: none;
    border-radius: 7px;
    text-align: left; cursor: pointer;
  }
  .sc-dropdown-item:hover { background: #fdf2f1; color: #a60808; }

  /* table */
  .sc-table-wrap {
    background: #fff;
    border-radius: 14px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }
  .sc-table-scroll { overflow-x: auto; }
  .sc-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;
  }
  .sc-table thead tr { background: #fdf2f1; }
  .sc-table th {
    padding: 15px 18px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
  }
  .sc-table td {
    padding: 15px 18px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
    font-size: 15px;
  }
  .sc-table tbody tr:hover td { background: #fdfafa; }

  /* avatar cell */
  .sc-av-cell { display: flex; align-items: center; gap: 10px; }
  .sc-av {
    width: 38px; height: 38px;
    border-radius: 50%;
    background: #fdf2f1;
    display: flex; align-items: center; justify-content: center;
    font-size: 13px; font-weight: 700; color: #a60808;
    flex-shrink: 0;
  }
  .sc-av-name { font-size: 15px; color: #333; font-weight: 600; }
  .sc-av-sub  { font-size: 13px; color: #bbb; margin-top: 2px; }

  .sc-phone { font-size: 14px; color: #666; font-family: monospace; }
  .sc-location { font-size: 14px; color: #888; display: flex; align-items: center; gap: 5px; }

  /* status pill */
  .sc-status-pill {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 5px 13px;
    border-radius: 20px;
    font-size: 13px; font-weight: 600;
    text-transform: capitalize;
  }
  .sc-status-pending   { background: #fdf2f1; color: #a32d2d; }
  .sc-status-approved  { background: #e6f1fb; color: #0c447c; }
  .sc-status-completed { background: #eaf3de; color: #27500a; }
  .sc-status-cancelled { background: #faeeda; color: #633806; }

  /* action buttons */
  .sc-act-wrap { display: flex; align-items: center; gap: 7px; flex-wrap: wrap; }

  .sc-view-btn {
    height: 34px; padding: 0 14px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #fff;
    font-size: 13.5px; color: #555;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
    white-space: nowrap;
  }
  .sc-view-btn:hover { background: #fdf2f1; border-color: #f0c0b8; color: #a60808; }
  .sc-view-btn i { font-size: 15px; }

  .sc-approve-btn {
    height: 34px; padding: 0 14px;
    border-radius: 9px;
    border: 1px solid #c0dda8;
    background: #fff;
    font-size: 13.5px; color: #3b6d11;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
  }
  .sc-approve-btn:hover { background: #eaf3de; }
  .sc-approve-btn i { font-size: 15px; }

  .sc-close-btn {
    height: 34px; padding: 0 14px;
    border-radius: 9px;
    border: 1px solid #f5d08a;
    background: #fff;
    font-size: 13.5px; color: #854f0b;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
  }
  .sc-close-btn:hover { background: #faeeda; }
  .sc-close-btn i { font-size: 15px; }

  .sc-cancel-btn {
    height: 34px; padding: 0 14px;
    border-radius: 9px;
    border: 1px solid #fcc;
    background: #fff;
    font-size: 13.5px; color: #a60808;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
  }
  .sc-cancel-btn:hover { background: #fdf2f1; }
  .sc-cancel-btn i { font-size: 15px; }

  /* pagination */
  .sc-pagination {
    display: flex; align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding: 16px 20px;
    border-top: 1px solid #f7f5f5;
  }
  .sc-show-row { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #888; }
  .sc-pg-btns  { display: flex; align-items: center; gap: 5px; }
  .sc-pg-btn {
    width: 36px; height: 36px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #fff;
    font-size: 14px; color: #555;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.18s;
  }
  .sc-pg-btn.active { background: #a60808; color: #fff; border-color: #a60808; }
  .sc-pg-btn:hover:not(.active):not(:disabled) { background: #fdf2f1; color: #a60808; }
  .sc-pg-btn:disabled { opacity: 0.4; cursor: default; }
`;

const STATUS_ICONS = {
  pending:   "ti-clock",
  approved:  "ti-circle-check",
  completed: "ti-trophy",
  cancelled: "ti-circle-x",
};

function SubscriptionChitUsersList() {
  const [list, setList]               = useState([]);
  const [statics, setStatics]         = useState(null);
  const [showSkelton, setShowSkelton] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [payload, setPayload] = useState({
    searchKey: "",
    status: "",
    pageNo: 1,
    pageCount: 10,
  });
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  const handleGetUsers = async () => {
    if (list.length === 0) setShowSkelton(true);
    try {
      const response = await getSubscriptionChitUsersListServ(payload);
      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);
      const totalCount = response?.data?.documentCount?.totalCount || 0;
      setTotalPages(Math.ceil(totalCount / payload.pageCount));
    } catch (error) {
      toast.error("Failed to fetch users.");
    }
    setShowSkelton(false);
  };

  useEffect(() => { handleGetUsers(); }, [payload]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages)
      setPayload({ ...payload, pageNo: newPage });
  };

  const handleApproveUser = async (id) => {
    try {
      const response = await approveSubscriptionChitUserServ(id);
      if (response?.data?.statusCode === 200) {
        toast.success("User approved successfully.");
        handleGetUsers();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Approval failed.");
    }
  };

  const handleCancelUser = async (id) => {
    try {
      const response = await cancelSubscriptionChitUserServ(id);
      if (response?.data?.statusCode === 200) {
        toast.success("Subscription cancelled successfully.");
        handleGetUsers();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Cancellation failed.");
    }
  };

  const handleCloseUser = async (id) => {
    try {
      const response = await closeSubscriptionChitUserServ(id);
      if (response?.data?.statusCode === 200) {
        toast.success("Subscription closed successfully.");
        handleGetUsers();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Closing failed.");
    }
  };

  const handleDownload = async (format) => {
    setShowDownloadMenu(false);
    try {
      const response = await exportSubscriptionChitUserServ(payload, format);
      const ext = format === "excel" ? "xlsx" : format;
      triggerFileDownload(response.data, `chitUserList.${ext}`);
    } catch (err) {
      toast.error("Download failed");
    }
  };

  const getInitials = (name = "") =>
    name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2) || "U";

  const staticsArr = [
    { title: "Total users",     count: statics?.totalCount,     icon: "ti-users",        bg: "#fdf2f1", color: "#a32d2d" },
    { title: "Pending",         count: statics?.pendingCount,   icon: "ti-clock",        bg: "#fdf2f1", color: "#a32d2d" },
    { title: "Approved",        count: statics?.approvedCount,  icon: "ti-circle-check", bg: "#e6f1fb", color: "#185fa5" },
    { title: "Completed",       count: statics?.completedCount, icon: "ti-trophy",       bg: "#eaf3de", color: "#3b6d11" },
    { title: "Cancelled",       count: statics?.cancelledCount, icon: "ti-circle-x",     bg: "#faeeda", color: "#854f0b" },
  ];

  return (
    <div className="bodyContainer">
      <style>{styles}</style>
      <Sidebar selectedMenu="Subscription" selectedItem="Chit User" />
      <div className="mainContainer">
        <TopNav pageTitle="Subscription Users" pagePath="Home / Subscription / Chit Users" />
        <div className="sc-page">

          {/* ── Stat Cards ── */}
          <div className="sc-stat-grid">
            {staticsArr.map((v, i) => (
              <div className="sc-stat-card" key={i}>
                <div className="sc-stat-icon" style={{ background: v.bg, color: v.color }}>
                  <i className={`ti ${v.icon}`} aria-hidden="true" />
                </div>
                <div>
                  <div className="sc-stat-val">{v.count ?? "—"}</div>
                  <div className="sc-stat-lbl">{v.title}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Toolbar ── */}
          <div className="sc-toolbar">
            <div className="sc-toolbar-title">Subscription users</div>
            <div className="sc-toolbar-right">
              <input
                className="sc-input"
                placeholder="Search by name, email or phone"
                onChange={(e) =>
                  setPayload({ ...payload, searchKey: e.target.value, pageNo: 1 })
                }
              />
              <select
                className="sc-select"
                onChange={(e) =>
                  setPayload({ ...payload, status: e.target.value, pageNo: 1 })
                }
              >
                <option value="">All users</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="completed">Completed</option>
                <option value="cancelled">Cancelled</option>
              </select>
              <div className="sc-download-wrap">
                <button
                  className="sc-btn-red"
                  onClick={() => setShowDownloadMenu((p) => !p)}
                >
                  <i className="ti ti-download" aria-hidden="true" />
                  Download
                </button>
                {showDownloadMenu && (
                  <div className="sc-dropdown-menu">
                    <button className="sc-dropdown-item" onClick={() => handleDownload("txt")}>
                      <i className="ti ti-file-text" aria-hidden="true" style={{ marginRight: 6 }} />
                      Download as TXT
                    </button>
                    <button className="sc-dropdown-item" onClick={() => handleDownload("excel")}>
                      <i className="ti ti-file-spreadsheet" aria-hidden="true" style={{ marginRight: 6 }} />
                      Download as Excel
                    </button>
                    <button className="sc-dropdown-item" onClick={() => handleDownload("csv")}>
                      <i className="ti ti-file" aria-hidden="true" style={{ marginRight: 6 }} />
                      Download as CSV
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* ── Table ── */}
          <div className="sc-table-wrap">
            <div className="sc-table-scroll">
              <table className="sc-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Location</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showSkelton ? (
                    [...Array(10)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(7)].map((__, j) => (
                          <td key={j} style={{ padding: "15px 18px", borderTop: "1px solid #f7f5f5" }}>
                            <Skeleton height={20} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td colSpan="7" style={{ textAlign: "center", padding: "48px" }}>
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list.map((v, i) => (
                      <tr key={v?._id}>
                        {/* Sr */}
                        <td style={{ color: "#aaa", fontSize: "14px" }}>
                          {(payload.pageNo - 1) * payload.pageCount + i + 1}
                        </td>

                        {/* Name */}
                        <td>
                          <div className="sc-av-cell">
                            <div className="sc-av">{getInitials(v?.name)}</div>
                            <div>
                              <div className="sc-av-name">{v?.name || "—"}</div>
                            </div>
                          </div>
                        </td>

                        {/* Phone */}
                        <td>
                          <span className="sc-phone">{v?.phone || "—"}</span>
                        </td>

                        {/* Email */}
                        <td style={{ fontSize: "14px", color: "#666" }}>
                          {v?.email || "—"}
                        </td>

                        {/* Location */}
                        <td>
                          <span className="sc-location">
                            <i className="ti ti-map-pin" style={{ fontSize: 14 }} aria-hidden="true" />
                            {v?.location || "—"}
                          </span>
                        </td>

                        {/* Status */}
                        <td>
                          <span className={`sc-status-pill sc-status-${v?.status}`}>
                            <i
                              className={`ti ${STATUS_ICONS[v?.status] || "ti-circle"}`}
                              style={{ fontSize: 13 }}
                              aria-hidden="true"
                            />
                            {v?.status}
                          </span>
                        </td>

                        {/* Actions */}
                        <td>
                          <div className="sc-act-wrap">
                            {/* View Details — always shown */}
                            <button
                              className="sc-view-btn"
                              onClick={() => navigate(`/subscription-details/${v?._id}`)}
                            >
                              <i className="ti ti-eye" aria-hidden="true" /> View
                            </button>

                            {/* Pending */}
                            {v?.status === "pending" && (
                              <>
                                <button
                                  className="sc-approve-btn"
                                  onClick={() => handleApproveUser(v?._id)}
                                >
                                  <i className="ti ti-circle-check" aria-hidden="true" /> Approve
                                </button>
                                <button
                                  className="sc-cancel-btn"
                                  onClick={() => handleCancelUser(v?._id)}
                                >
                                  <i className="ti ti-x" aria-hidden="true" /> Cancel
                                </button>
                              </>
                            )}

                            {/* Approved */}
                            {v?.status === "approved" && (
                              <>
                                <button
                                  className="sc-close-btn"
                                  onClick={() => handleCloseUser(v?._id)}
                                >
                                  <i className="ti ti-lock" aria-hidden="true" /> Close
                                </button>
                                <button
                                  className="sc-cancel-btn"
                                  onClick={() => handleCancelUser(v?._id)}
                                >
                                  <i className="ti ti-x" aria-hidden="true" /> Cancel
                                </button>
                              </>
                            )}

                            {/* Cancelled — static pill */}
                            {v?.status === "cancelled" && (
                              <span className="sc-status-pill sc-status-cancelled">
                                <i className="ti ti-circle-x" style={{ fontSize: 13 }} aria-hidden="true" />
                                Cancelled
                              </span>
                            )}

                            {/* Completed — static pill */}
                            {v?.status === "completed" && (
                              <span className="sc-status-pill sc-status-completed">
                                <i className="ti ti-trophy" style={{ fontSize: 13 }} aria-hidden="true" />
                                Completed
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Pagination ── */}
            <div className="sc-pagination">
              <div className="sc-show-row">
                Show
                <select
                  className="sc-select"
                  style={{ height: "34px", padding: "0 10px" }}
                  value={payload.pageCount}
                  onChange={(e) =>
                    setPayload({ ...payload, pageCount: parseInt(e.target.value), pageNo: 1 })
                  }
                >
                  {[10, 25, 50, 100].map((v) => (
                    <option key={v} value={v}>{v}</option>
                  ))}
                </select>
                entries
              </div>

              <div className="sc-pg-btns">
                <button
                  className="sc-pg-btn"
                  disabled={payload.pageNo === 1}
                  onClick={() => handlePageChange(payload.pageNo - 1)}
                >
                  <i className="ti ti-chevron-left" style={{ fontSize: "14px" }} />
                </button>

                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (
                    page === 1 || page === totalPages ||
                    (page >= payload.pageNo - 1 && page <= payload.pageNo + 1)
                  ) {
                    return (
                      <button
                        key={page}
                        className={`sc-pg-btn ${payload.pageNo === page ? "active" : ""}`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    );
                  } else if (
                    (page === payload.pageNo - 2 && page > 2) ||
                    (page === payload.pageNo + 2 && page < totalPages - 1)
                  ) {
                    return <button key={page} className="sc-pg-btn" disabled>...</button>;
                  }
                  return null;
                })}

                <button
                  className="sc-pg-btn"
                  disabled={payload.pageNo === totalPages}
                  onClick={() => handlePageChange(payload.pageNo + 1)}
                >
                  <i className="ti ti-chevron-right" style={{ fontSize: "14px" }} />
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default SubscriptionChitUsersList;